import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { t } from "@/lib/i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("wpe_lang") || "es");

  useEffect(() => {
    localStorage.setItem("wpe_lang", lang);
    document.documentElement.lang = lang;
    // Belt-and-suspenders against browser auto-translation (Chrome,
    // Safari, Edge). The app owns its ES/EN switching via i18n.js; if a
    // browser overlays its own translation the learner sees mixed copy
    // like "Essential / Hotel Industry / Trade" for BASIC / HOSPITALITY
    // / RETAIL, which contradicts the canonical taxonomy.
    document.documentElement.setAttribute("translate", "no");
  }, [lang]);

  const toggle = () => setLang((prev) => (prev === "es" ? "en" : "es"));

  const value = useMemo(() => ({ lang, setLang, toggle, tr: (k) => t(lang, k) }), [lang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
